@link fn getScissorParams() -> vec4<f32>;
@link fn getScissorChannel() -> i32;
@link fn getScissorBias() -> f32;

@export fn getScissorPlane(value: vec4<f32>) -> vec4<f32> {

  let plane = getScissorParams();
  var channel = getScissorChannel();
  let bias = getScissorBias();

  let normal = plane.xyz;
  let offset = plane.w + bias;

  var o = dot(normal, value.xyz) + offset;
  var v = vec4<f32>(1e5);

  if (channel == -1) {
    let na = abs(normal);
    let ma = max(na.x, max(na.y, na.z));
    if (ma == na.x) {
      channel = 0;
    }
    else if (ma == na.y) {
      channel = 1;
    }
    else {
      channel = 2;
    }
  }

  if (channel == 0) {
    v.x = o;
  }
  else if (channel == 1) {
    v.y = o;
  }
  else if (channel == 2) {
    v.z = o;
  }
  else if (channel == 3) {
    v.w = o;
  }

  return v;
};
